import { render } from "./PartnerSplashPage.vue?vue&type=template&id=08c8b5d6"
import script from "./PartnerSplashPage.vue?vue&type=script&lang=js"
export * from "./PartnerSplashPage.vue?vue&type=script&lang=js"

import "./PartnerSplashPage.vue?vue&type=style&index=0&id=08c8b5d6&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__